import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rmvLeadingZeroes',
  standalone: false,
})
export class RmvLeadingZeroesPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/\b0+/g, '');
  }
}
